
<div class="modal-header" translate>Could not contact the ELEMENTS Client</div>
<div class="modal-body">
  <p translate>The ELEMENTS client does not appear to be running on your machine.</p>
  <div class="image"><img src="/assets/client.png" [alt]="'ELEMENTS client'|translate"></div>
</div>
<div class="modal-footer">
  <button class="btn btn-outline-primary" (click)="modalInstance.close()">Retry</button>
</div>